import React from 'react';
import { t } from 'i18n';
import { HeadSection } from 'components/HeadSection';
import { BuildPc } from 'containers/BuildPc';
import { useBuildPCV2 } from 'contexts';
import { useTenantConfig } from 'hooks';
import { PbPageProps } from 'modules/page-builder';
import dynamic from 'next/dynamic';
import {
  BreadcrumbProps,
  Breadcrumbs,
  Container,
  styled,
} from '@teko/ds-desktop';
import { Loading } from 'components/Loading';
import { PrintBuildPc } from '@teko/ecommerce';

const PbBuildPC = dynamic(() =>
  import('../../page-builder').then((mod) => mod.PbPage),
);

export const BuildPC: React.FC<PbPageProps> = ({
  pbContent,
  pbMetaData,
  pbSSRData,
}) => {
  const { epicOmni1524 } = useTenantConfig();
  const { loading, estimatedAmount, mappedPrintBuildPCData } = useBuildPCV2();

  const breadCrumbs: BreadcrumbProps[] = [
    {
      link: '/',
      name: t('Trang chủ'),
    },
    {
      disabled: true,
      link: '#',
      name: 'Build PC',
    },
  ];

  return epicOmni1524 ? (
    <>
      <Loading isLoading={loading || false}>
        <StyledContainer>
          <HeadSection
            {...(pbMetaData
              ? {
                  title: pbMetaData.metaTitle,
                  description: pbMetaData.metaDescription,
                  keywords: pbMetaData.metaKeywords?.toString(),
                }
              : {})}
          />
          <Container>
            <Breadcrumbs breadcrumbs={breadCrumbs} />
          </Container>
          <PbBuildPC
            pbContent={pbContent}
            pbSSRData={pbSSRData}
            pbMetaData={pbMetaData}
            page="buildpc"
          ></PbBuildPC>
        </StyledContainer>
      </Loading>
      <PrintBuildPc
        total={estimatedAmount}
        buildpc={mappedPrintBuildPCData}
        logoProps={{ height: '60px' }}
      />
    </>
  ) : (
    <BuildPc />
  );
};

const StyledContainer = styled(Container)`
  @media print {
    display: none;
  }
`;
